var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"google-slides-content",class:{'no-control-box': !_vm._hasControlBox()}},[_c('iframe',{staticClass:"google-slides-iframe",attrs:{"src":_vm.$store.state.slideActive.publishedLink,"frameborder":"0","width":"997.33","height":"590","allowfullscreen":"true","mozallowfullscreen":"true","webkitallowfullscreen":"true"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }